import { createAction } from 'shared';

export const fetchAppQrRelations = createAction('FETCH_APP_QR_RELATIONS', 'ids', 'entities');
